/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Sign_In_DescriptionInputs */

const fr_auth_sign_in_description = /** @type {(inputs: Auth_Sign_In_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectez-vous avec le compte Google de votre entreprise.`)
};

const en_auth_sign_in_description = /** @type {(inputs: Auth_Sign_In_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in with your company Google account.`)
};

/**
* | output |
* | --- |
* | "Sign in with your company Google account." |
*
* @param {Auth_Sign_In_DescriptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_sign_in_description = /** @type {((inputs?: Auth_Sign_In_DescriptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Sign_In_DescriptionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_sign_in_description(inputs)
	return fr_auth_sign_in_description(inputs)
});